import { useStickyBottomBarContext } from "contexts/StickyBottomBarContext";
import { useDeviceSize } from "hooks";
import { ChakraSlide as Slide } from "@airhelp/react-ui-components";
import { iconsWithText } from "./StickyBottomBar.config";
import type { StickyBottomBarProps } from "./StickyBottomBar.d";
import StickyBottomBarDesktop from "./StickyBottomBarDesktop";
import StickyBottomBarMobile from "./StickyBottomBarMobile";

const StickyBottomBar = ({ heading, variant }: StickyBottomBarProps) => {
  const { isDesktop } = useDeviceSize();
  const { isOpen } = useStickyBottomBarContext();

  return (
    <Slide in={isOpen} direction="bottom" style={{ zIndex: 2, transition: ".1s" }} data-testid="sticky-bottom-bar">
      {isDesktop ? (
        <StickyBottomBarDesktop iconsWithText={iconsWithText} heading={heading} variant={variant} />
      ) : (
        <StickyBottomBarMobile iconsWithText={iconsWithText} variant={variant} heading={heading} />
      )}
    </Slide>
  );
};

export default StickyBottomBar;
